import { tactonSystemDataAPI, tactonSystemDataConstants } from "./tacton";
var defaultAPI = tactonSystemDataAPI;
export default defaultAPI;
export var systemDataConstants = tactonSystemDataConstants;
